export enum FtblPlayerRole {
    Goalkeeper = 0,
    Back = 1,
    Halfback = 2,
    Forward = 3,
    Reserve = 4,
}

const FTBL_PLAYER_ROLE_BACKGROUND: Record<FtblPlayerRole, string> = {
    [FtblPlayerRole.Goalkeeper]: '#B9D9C7',
    [FtblPlayerRole.Back]: '#F1BDC5',
    [FtblPlayerRole.Halfback]: '#CDE9F7',
    [FtblPlayerRole.Forward]: '#FDEDD1',
    [FtblPlayerRole.Reserve]: '#B9D9C7',
};

export const getFtblPlayerRoleBackgroundColor = (role?: number): string => {
    return FTBL_PLAYER_ROLE_BACKGROUND[role as FtblPlayerRole] || FTBL_PLAYER_ROLE_BACKGROUND[FtblPlayerRole.Goalkeeper];
};
export enum FtblPlayerRole {
    Goalkeeper = 0,
    Back = 1,
    Halfback = 2,
    Forward = 3,
    Reserve = 4,
}

const FTBL_PLAYER_ROLE_BACKGROUND: Record<FtblPlayerRole, string> = {
    [FtblPlayerRole.Goalkeeper]: '#B9D9C7',
    [FtblPlayerRole.Back]: '#F1BDC5',
    [FtblPlayerRole.Halfback]: '#CDE9F7',
    [FtblPlayerRole.Forward]: '#FDEDD1',
    [FtblPlayerRole.Reserve]: '#B9D9C7',
};

export const getFtblPlayerRoleBackgroundColor = (role?: number): string => {
    return FTBL_PLAYER_ROLE_BACKGROUND[role as FtblPlayerRole] || FTBL_PLAYER_ROLE_BACKGROUND[FtblPlayerRole.Goalkeeper];
};
